import { withRouter } from "react-router-dom";

import WorkoutDetailsPage from "./HorseWorkoutsPage";

export default withRouter(WorkoutDetailsPage);
